module.exports = __webpack_public_path__ + "img/B3.91ee0b0d.svg";